import removeKey from "LIB/removeKey";
import { SERVICEABLE_TOOLING } from "MODULES/IncomingQuotes/constants";

export const AFTER_INTERNAL_OUTRIGHT = "after_internal_outright";
export const ASKING_INTERNAL_OUTRIGHT = "asking_internal_outright";
export const ASKING_EXPECTED_COMPONENTS = "asking_expected_components";
export const OVERHAULED = "overhauled";
export const REPAIRED = "repaired";
export const INSPECTED = "inspected";
export const NEW_ITEM = "new_item";
export const AS_REMOVED = "as_removed";
export const BEYOND_REPAIR = "beyond_econ_repair";
export const CORE_RETURN_FEE_SAVINGS = "core_return_fee_savings";
export const ESTIMATED_LEAD_TIME = "estimated_lead_time";
export const EXPECTED_DATE = "expected_date";
export const LABOR_COST = "labor_cost";
export const OUTSIDE_LABOR_COST = "outside_labor_cost";
export const PART_COST = "part_cost";
export const PARTIAL_CREDIT = "partial_credit";
export const PARTIAL_CREDIT_AMOUNT = "partial_credit_amount";
export const PARTS_UNIT = "parts_unit";
export const REMOVE_EXPECTED_COMPONENTS = "remove_expected_components";
export const REMAINING_COST = "remaining_cost";
export const REPAIR_AND_HOLD = "repair_and_hold";
export const REPAIR_AND_HOLD_LEAD_TIME = "repair_and_hold_lead_time";
export const RMA_REQUEST_TYPE = "rma_request_type";
export const SCRAP = "scrap";
export const SHOP_ASSIST_COST = "shop_assist_cost";
export const TRANSFER_COST = "transfer_cost";

export const CANCELLED = "cancelled";
export const CLOSED = "closed";
export const CORE_RETURN_DATE = "core_return_date";
export const CORE_RETURN_RECEIVED_DATE_LABEL = "core_return_received_date";
export const CORE_RETURN_DUE_DATE = "core_return_due_date";
export const CORE_REPAIR_INVOICES_PAID = "core_repair_invoices_paid";
export const CORE_DUE_DAYS = "core_due_days";
export const CORE_EXPECTED_DATE = "core_expected_date";
export const DATE_RECEIVED = "date_received";
export const EVAL_DUE_DATE = "eval_due_date";
export const PURCHASE_FOR_EXCHANGE = "purchase_for_exchange";
export const INCOMING_AWB_NUMBER = "incoming_awb_number";
export const MOD_TO = "mod_to";
export const MOD_TO_ID = "mod_to_id";
export const OPENED = "opened";
export const REQUESTED = "requested";

export const REPAIR_LINE_ITEMS = {
  condition: {
    [OVERHAULED]: {
      abbrev: "OH",
      label: "Overhauled"
    },
    [REPAIRED]: {
      abbrev: "SV",
      label: "Repaired"
    },
    [INSPECTED]: {
      abbrev: "BT",
      label: "Inspected"
    },
    [NEW_ITEM]: {
      abbrev: "NE",
      label: "New"
    },
    [AS_REMOVED]: {
      abbrev: "AR",
      label: "As Removed"
    },
    [BEYOND_REPAIR]: {
      abbrev: "BR",
      label: "Beyond Repair"
    },
    [PARTS_UNIT]: {
      abbrev: "PU",
      label: "Parts Unit"
    },
    [SCRAP]: {
      abbrev: "SC",
      label: "Scrap"
    },
    [SERVICEABLE_TOOLING]: {
      abbrev: "SV",
      label: "Serviceable Tooling"
    }
  }
};

export const ACTION_REQUESTED = "action_requested";
export const APPROVAL_STATUS = "approval_status";
export const CORE_REPAIR_HOLD = "core_repair_hold";
export const EVAL_STATUS = "eval_status";
export const EXCHANGE_GONE_OUTRIGHT = "exchange_gone_outright";
export const EVALUATION_CHARGE = "evaluation_charge";
export const EXPECTED_SERIAL_NUMBER = "expected_serial_number";
export const FINAL_EVALUATION_APPROVED = "final_evaluation_approved";
export const INTERNAL_OUTRIGHT = "internal_outright";
export const NOT_TO_EXCEED = "not_to_exceed";
export const ORIGINAL_EVALUATION = "original_evaluation";
export const BENCH_TEST = "bench_test";
export const EXPECTED_COMPONENT = "expected_component";
export const EXCHANGE = "exchange";
export const OVERHAUL = "overhaul";
export const RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT =
  "recovered_repair_from_internal_outright";
export const REPAIR = "repair";
export const RETURNED_DATE = "returned_date";
export const SHOP_ASSIST = "shop_assist";
export const TEARDOWN = "teardown";
export const WARRANTY_CONSIDERATION = "warranty_consideration";

export const ACTIONS_REQUESTED = {
  [BENCH_TEST]: {
    label: "Bench Test",
    abbrev: "BT"
  },
  [REPAIR]: {
    label: "Repair",
    abbrev: "SV"
  },
  [OVERHAUL]: {
    label: "Overhaul",
    abbrev: "OH"
  },
  [WARRANTY_CONSIDERATION]: {
    label: "Warranty Consideration",
    abbrev: "WC"
  },
  [SHOP_ASSIST]: {
    label: "Shop Assist",
    abbrev: "SA"
  },
  [TEARDOWN]: {
    label: "Teardown",
    abbrev: "TD"
  },
  [EXPECTED_COMPONENT]: {
    label: "Expected Sub-Component",
    abbrev: "EC"
  }
};

export const AWAITING_TO_SHIP = "awaiting_to_ship";
export const NO_WORK_PERFORMED = "no_work_performed";
export const REPAIR_EVALUATION_APPROVED = "repair_evaluation_approved";
export const REPAIR_AWAITING_EVALUATION = "repair_awaiting_evaluation";
export const REPAIR_EVALUATION_REJECTED = "repair_evaluation_rejected";
export const WORKING_TO_SAVE_UNIT = "working_to_save_unit";
export const REPAIR_EVALUATION_RECEIVED = "repair_evaluation_received";
export const UNIT_RETURNED_TO_CUSTOMER = "unit_returned_to_customer";

export const APPROVAL_STATUSES = {
  [AWAITING_TO_SHIP]: {
    label: "Awaiting To Ship"
  },
  [REPAIR_AWAITING_EVALUATION]: {
    label: "Awaiting Eval."
  },
  [REPAIR_EVALUATION_RECEIVED]: {
    label: "Eval. Received"
  },
  [REPAIR_EVALUATION_APPROVED]: {
    label: "Eval. Approved"
  },
  [REPAIR_EVALUATION_REJECTED]: {
    label: "Eval. Rejected"
  },
  [NO_WORK_PERFORMED]: {
    label: "No Work Performed"
  },
  [WORKING_TO_SAVE_UNIT]: {
    label: "Working to Save Unit"
  },
  [UNIT_RETURNED_TO_CUSTOMER]: {
    label: "Unit Returned To Customer"
  }
};

export const EVAL_STATUS_BADGE_CONTENT = {
  [AWAITING_TO_SHIP]: {
    icon: "fa fa-fw fa-truck",
    text: "text-warning",
    label: "Awaiting To Ship",
    abbrev: "Aw To Ship"
  },
  [NO_WORK_PERFORMED]: {
    icon: "fa fa-fw fa-minus-square",
    text: "text-warning",
    label: "No Work Performed",
    abbrev: "No Work"
  },
  [REPAIR_EVALUATION_APPROVED]: {
    icon: "fa fa-fw fa-check",
    text: "text-success",
    label: "Eval. Approved",
    abbrev: "Eval Appr"
  },
  [REPAIR_AWAITING_EVALUATION]: {
    icon: "fa fa-fw fa-clock-o",
    text: "text-warning",
    label: "Awaiting Eval.",
    abbrev: "Aw Eval"
  },
  [WORKING_TO_SAVE_UNIT]: {
    icon: "fa fa-fw fa-clock-o",
    text: "text-warning",
    label: "Working to Save Unit",
    abbrev: "WTSU"
  },
  [REPAIR_EVALUATION_RECEIVED]: {
    icon: "fa fa-fw fa-clock-o",
    text: "text-warning",
    label: "Eval. Received",
    abbrev: "Eval Rec"
  },
  [REPAIR_EVALUATION_REJECTED]: {
    icon: "fa fa-fw fa-warning",
    text: "text-danger",
    label: "Eval. Rejected",
    abbrev: "Eval Rej"
  },
  [UNIT_RETURNED_TO_CUSTOMER]: {
    icon: "fa fa-fw fa-undo",
    text: "text-warning",
    label: "Returned To Customer",
    abbrev: "Returned To Cus"
  }
};

export const APPROVED = "approved";
export const PENDING = "pending";
export const DENIED = "denied";

export const APPROVAL_OPTIONS = {
  [APPROVED]: {
    label: "Approved"
  },
  [PENDING]: {
    label: "Pending"
  },
  [DENIED]: {
    label: "Denied"
  }
};

export const APPROVE_OR_DENY_OPTIONS = removeKey(APPROVAL_OPTIONS, PENDING);
export const REPAIR_STATION_WARRANTY_STATUS = "repair_station_warranty_status";
export const WARRANTY_STATUS = "warranty_status";

export const ATTACHMENT_TYPES = {
  approved_original_evaluation: {
    label: "Approved Original Evaluation"
  },
  denied_original_evaluation: {
    label: "Denied Original Evaluation"
  },
  repair_evaluation: {
    label: "Repair Evaluation"
  },
  photos_from_repair_station: {
    label: "Photos - From Repair Station"
  },
  external_link: {
    label: "External Link"
  },
  original_evaluation: {
    label: "Original Evaluation"
  },
  repair_station_correspondence: {
    label: "Repair Station Correspondence"
  },
  other: {
    label: "Other"
  }
};

export const AMOUNT = "Amount";
export const NONE = "None";
export const PERCENT = "Percent";

export const INSURANCE_TYPES = {
  [AMOUNT]: {
    key: "amount_insured"
  },
  [NONE]: {
    value: "Do Not Insure"
  },
  [PERCENT]: {
    key: "percent_insured"
  }
};

export const REASONS_FOR_RETURN = [
  {
    value: "failed_test_or_install",
    text: "Unit failed at test or install"
  },
  {
    value: "no_longer_required",
    text: "Unit no longer required"
  },
  {
    value: "wrong_unit_ordered",
    text: "Wrong unit ordered"
  },
  {
    value: "failed_inspection",
    text: "Unit failed incoming inspection"
  },
  {
    value: "condition_rejection",
    text:
      "Unit is rejected due to condition but will be accepted back without sending to shop"
  },
  {
    value: "other",
    text: "Other"
  }
];

export const getConditionLabel = condition => {
  if (!condition) return null;
  return REPAIR_LINE_ITEMS.condition[condition].label;
};

export const getConditionAbbrev = condition => {
  if (!condition) return null;
  return REPAIR_LINE_ITEMS.condition[condition].abbrev;
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/constants.js